export default "__VITE_ASSET__DhUwA34U__"